// src/App.js
import React from "react";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";

function AppContent() {
  const { currentUser, isAdmin, loading } = useAuth();

  if (loading) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"#f7f8fc" }}>
      <div style={{ textAlign:"center" }}>
        <div style={{ fontSize:"3rem", marginBottom:"1rem" }}>🎟️</div>
        <div style={{ color:"#667eea", fontWeight:"600" }}>Chargement…</div>
      </div>
    </div>
  );

  if (!currentUser) return <Login />;

  if (!isAdmin) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"#f7f8fc" }}>
      <div style={{ textAlign:"center", background:"#fff", padding:"2.5rem", borderRadius:"16px", boxShadow:"0 4px 24px rgba(0,0,0,0.08)" }}>
        <div style={{ fontSize:"3rem", marginBottom:"1rem" }}>🚫</div>
        <h2 style={{ color:"#1a1a2e", marginBottom:"0.5rem" }}>Accès refusé</h2>
        <p style={{ color:"#888" }}>Vous n'avez pas les droits d'accès à ce back-office.</p>
      </div>
    </div>
  );

  return <Dashboard />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
